<template>
    <div v-if="visible">
        <el-dialog title="修改指标" :close-on-click-modal="false" 
            :visible.sync="visible" :before-close="dialogClose" width="750px">

            <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
                <el-tab-pane label="表扬" name="first">
                    <child1 v-if="activeName == 'first'"></child1>
                </el-tab-pane>

                <el-tab-pane label="待改进" name="second">
                    <child2 v-if="activeName == 'second'"></child2>    
                </el-tab-pane>

            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
    import praiseList from './index/praiseList';
    import improveList from './index/improveList'

    export default {
        name:"EvaluateMain",
        components:{
            child1:praiseList,
            child2:improveList,
        },
        data() {
            return {
                //默认第一个选项卡
                activeName: "first",
                visible:false,
            }
        },
        methods:{
            handleClick(tab) {
                 if(tab.name == "first") {
                    this.activeName="first";
                }else if(tab.name == "second") {
                    this.activeName="second";
                }
            },
            init(userId,classId){
                this.visible=true;
                // console.log('userId:'+userId+"，classId："+classId);
                sessionStorage.setItem('userId',userId);
                sessionStorage.setItem('classId',classId);
                this.activeName = 'first';
            },
            dialogClose(done){
                done();
                this.$reload;
            },
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/set/classroomtime/indexMain.vue